let clientId = 'muven-admin'

if (process.env.NODE_ENV === 'development') {
  clientId = 'muven-admin-dev'
}

export const initOptions = {
  realm: 'c2b', 
  url: 'https://accounts.c2bsoftware.com.br/auth', 
  clientId,
}
